module.exports = __webpack_public_path__ + "img/morethanlease_3.f95d8782.webp";